import { useState, useEffect } from "react";
import GridIndex from "../../../components/GridIndex";
import { Box, Tooltip, Typography, IconButton } from "@mui/material";
import axios from "../../../services/Api";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import useBreadcrumbs from "../../../hooks/useBreadcrumbs";

import { convertToDateandTime } from "../../../utils/Utils";

function AttendServiceTransportCancelledIndex() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const setCrumbs = useBreadcrumbs();
  const userId = JSON.parse(sessionStorage.getItem("AcharyaErpUser"))?.userId;
  const [deptId, setDeptId] = useState([]);
  const navigate = useNavigate();
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});

  useEffect(() => {
    if (userId) {
      getDeptId(userId);
    }
  }, []);

  useEffect(() => {
    if (deptId?.dept_id) {
      getData(deptId?.dept_id);
    }
    setCrumbs([
      { name: "Service Render", link: "/ServiceRender" },
      { name: "Void Indents" },
    ]);
  }, [deptId]);

  const getDeptId = async (userId) => {
    await axios
      .get(`/api/getDeptIdBasedOnUserId/${userId}`)
      .then((res) => {
        setDeptId(res.data.data[0]);
      })
      .catch((error) => console.error(error));
  };

  const getData = async (deptId) => {
    setLoading(true);
    await axios
      .get(
        `/api/fetchAllTransportMaintenanceCancelled?page=0&page_size=1000000&sort=modified_date`,
      )
      .then((res) => {
        setRows(res.data.data.Paginated_data.content);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const columns = [
    {
      field: "view",
      headerName: "View Vehicle Indent",
      type: "actions",
      flex: 1,
      getActions: (params) => [
        <IconButton
          color="primary"
          onClick={() =>
            navigate(
              "/ServiceRenderTransport/attendHistory/ViewVehicleIndent",
              {
                state: { row: params?.row },
              },
            )
          }
        >
          <VisibilityIcon fontSize="small" />
        </IconButton>,
      ],
    },
    { field: "type_of_vehicle", headerName: "Type Of Vehicle", flex: 1 },
    { field: "vehicleModel", headerName: "Model", flex: 1 },
    { field: "vehicleNo", headerName: "Vehicle No.", flex: 1 },
    { field: "reporting_place", headerName: "Reporting Place", flex: 1 },
    {
      field: "requesting_from_datetime",
      headerName: "PickUp Date&Time",
      flex: 1,
      renderCell: (params) => (
        <Tooltip
          title={convertToDateandTime(params.row.requesting_from_datetime)}
          arrow
        >
          <Typography
            variant="body2"
            sx={{
              textTransform: "capitalize",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {convertToDateandTime(params.row.requesting_from_datetime)}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "requesting_to_datetime",
      headerName: "Droping Date&Time",
      flex: 1,
      renderCell: (params) => (
        <Tooltip
          title={convertToDateandTime(params.row.requesting_to_datetime)}
          arrow
        >
          <Typography
            variant="body2"
            sx={{
              textTransform: "capitalize",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {convertToDateandTime(params.row.requesting_to_datetime)}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "is_round_trip",
      headerName: "Round Trip",
      flex: 1,
      renderCell: (params) => {
        const v = params.row.is_round_trip;
        const yes =
          v === true || v === "true" || v === "yes" || v === 1 || v === "1";
        return yes ? "Yes" : "No";
      },
    },
    {
      field: "return_from_datetime",
      headerName: "Return Date&Time",
      flex: 1,
      renderCell: (params) => {
        const value = params.row.return_from_datetime;
        if (!value) return "";
        return (
          <Tooltip
            title={convertToDateandTime(value)}
            arrow
          >
            <Typography
              variant="body2"
              sx={{
                textTransform: "capitalize",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {convertToDateandTime(value)}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "return_to_datetime",
      headerName: "Arrival Back Date&Time",
      flex: 1,
      renderCell: (params) => {
        const value = params.row.return_to_datetime;
        if (!value) return "";
        return (
          <Tooltip
            title={convertToDateandTime(value)}
            arrow
          >
            <Typography
              variant="body2"
              sx={{
                textTransform: "capitalize",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {convertToDateandTime(value)}
            </Typography>
          </Tooltip>
        );
      },
    },
    { field: "duration", headerName: "Duration", flex: 1 },
    { field: "report_to_person", headerName: "Reporting Person", flex: 1 },
    { field: "place_of_visit", headerName: "Place Of Visit", flex: 1 },
    {
      field: "purpose",
      headerName: "Purpose",
      flex: 1,
    },
    {
      field: "request_status",
      headerName: "Request Status",
      flex: 1,
    },
  ];

  return (
    <Box sx={{ position: "relative", mt: 3 }}>
      <Box sx={{ position: "absolute", width: "100%" }}>
        <GridIndex
          rows={rows}
          columns={columns}
          loading={loading}
          columnVisibilityModel={columnVisibilityModel}
          setColumnVisibilityModel={setColumnVisibilityModel}
        />
      </Box>
    </Box>
  );
}

export default AttendServiceTransportCancelledIndex;
